import axios from 'axios'
import store from '@/store'
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 25000
})

service.interceptors.request.use(
  config => {
      // if (store.getters.token) {
      // config.headers['Authorization'] = `Bearer ${store.getters.token || ''}` // 讓每個請求攜帶自定義token 請根據實際情況自行修改
      config.headers['Authorization'] = `Bearer ${store.getters.firebaseToken}` // 讓每個請求攜帶自定義token 請根據實際情況自行修改
      config.headers['X-Requested-With'] = `XMLHttpRequest`
      config.headers['Content-Type'] = `application/json`
    // }
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response
    return res
  },
  error => {
    if (error.response.status === 403 || error.response.status === 401) {

    } else {

    }
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js